import { IMask } from 'react-imask'
/**
 * `maskAValue` applies a given mask to a given value to format it in that specific way
 *
 * E.g.:
 *  maskAValue('000 000', '7689') -> '768 9'
 *
 * @param mask [string] PatterMask to be used. Reference: https://imask.js.org/guide.html#masked-pattern
 * @param unmaskedValue [string] string value to be formatted with the given mask
 * @returns [string] if all params are valid, value with the mask applied to it
 */
const maskAValue = (mask: string, unmaskedValue: string): string => {
  if (!unmaskedValue) {
    return ''
  }
  if (!mask) {
    return unmaskedValue
  }
  const maskedValue = IMask.createMask({ mask })
  maskedValue.resolve(unmaskedValue)
  return maskedValue.value
}

export default maskAValue
